<div
  class="profileContainer uk-animation-slide-bottom-small"
  uk-parallax="opacity: 1,0"
>
  <div class="profilePic uk-margin-medium-top"></div>

  <div class="particles">
    <ng-particles
      [id]="id"
      [options]="particlesOptions"
      (particlesLoaded)="particlesLoaded($event)"
      (particlesInit)="particlesInit($event)"
    ></ng-particles>
  </div>
</div>

<div
  id="jumbotron"
  uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky"
>
  <div class="uk-card uk-align-center uk-card-default">
    <div class="uk-card-header uk-container">
      <div class="uk-grid uk-grid-small uk-flex-middle" uk-grid>
        <div class="uk-width-expand uk-animation-slide-bottom-small">
          <h3 class="uk-card-title uk-margin-remove-bottom">
            Antonis Anagnostou
          </h3>
          <p class="uk-text-meta uk-margin-remove-top">SENIOR MACHINE LEARNING ENGINEER</p>
        </div>
      </div>
    </div>
  </div>
</div>
